import { PropertiesPanelContent, PropertiesPanelPropertyConfig } from '../../../../../widgets/propertiesPanel';

// I MATTONI CHE PIÙ PANNELLI USANO, in un posto solo.
//
// Una terna di coordinate la chiedono gli oggetti — posizione, rotazione, scala — le luci e le
// camere, e ognuno se l'era scritta per conto suo: tre volte le stesse dodici righe, con tre
// occasioni di scrivere `0.1` dove gli altri hanno `0.01`. Quello che è uguale si dichiara una
// volta; quello che è diverso lo passa chi chiama.
const createPropertyConfig = <T extends PropertiesPanelContent>(config: T) => config;

/**
 * Un campo per asse — X, Y, Z — sotto un'etichetta sola. `unit` per i gradi; assente per le
 * distanze.
 *
 * `disabled` è il lucchetto: una cosa bloccata si legge e non si tocca — spegnere i campi è il
 * modo in cui il pannello lo dice, e vale come il gizmo che non si attacca.
 */
export const createTripleNumberConfig = (
    id: string,
    label: string,
    values: [number, number, number],
    onChange: (axis: 'x' | 'y' | 'z', value: number) => void,
    unit?: string,
    disabled?: boolean
): PropertiesPanelPropertyConfig =>
    createPropertyConfig({
        type: 'point',
        id,
        label,
        disabled,
        coords: [
            {
                id: 'x',
                label: 'X',
                step: 0.01,
                unit,
                value: values[0],
                onChange: (newValue) => onChange('x', newValue)
            },
            {
                id: 'y',
                label: 'Y',
                step: 0.01,
                unit,
                value: values[1],
                onChange: (newValue) => onChange('y', newValue)
            },
            {
                id: 'z',
                label: 'Z',
                step: 0.01,
                unit,
                value: values[2],
                onChange: (newValue) => onChange('z', newValue)
            }
        ]
    });
